export default __webpack_public_path__ + "static/media/CNo.41-4.132f80ac.jpg";